module.exports = "<div class=\"chat\" style=\"height: 490px;\">\n   <img src=\"./assets/images/logo/logo.png\" style=\"padding:30%;\">\n</div>\n"